<template>
  <div class="view-container">
    <div class="card">
      <div class="card-header card-header-divider">
        <div class="card-title">
          {{ route.params.id ? 'Редактирование' : 'Создание' }} текста
        </div>
      </div>
      <div class="card-body">
        <div v-if="!loadPreloader" class="form">
          <div>
            <custom-select-2
                v-model="form.report_type"
                name="role"
                label="Роль"
                :options="[
                 {id: 'employee', text: 'Сотрудник'},
                 {id: 'employer', text: 'Заказчик'},
                 {id: 'standard', text: 'Стандартный'}
               ]"
                :disabled="route.params.id > 0"
            />
          </div>
          <div>
            <div v-if="route.params.id > 0">
              <custom-input name="title" :label="'Заголовок'" v-model="form.title" disabled="true"/>
            </div>
            <div v-else class="title_list">
              <custom-select-2
                  v-model="form.title"
                  name="title_select"
                  label="Наименование"
                  :options="currentTextTypes"
              />
            </div>
            <div class="textarea_wrapper">
              <custom-textarea name="text" :label="'Текст'" :height="300" v-model="form.text"/>
            </div>
          </div>
          <div class="scores_wrapper">
            <div class="score_group">
              <p>Балл 1-го раздела</p>
              <div class="input_group">
                <custom-input name="score1_from"
                              label="От"
                              v-model="form.scores1_from"
                />
                <custom-input name="score1_to"
                              label="До"
                              v-model="form.scores1_to"
                />
              </div>
            </div>
            <div class="score_group">
              <p>Балл 2-го раздела</p>
              <div class="input_group">
                <custom-input name="score2_from"
                              label="От"
                              v-model="form.scores2_from"
                />
                <custom-input name="score2_to"
                              label="До"
                              v-model="form.scores2_to"
                />
              </div>
            </div>
          </div>
          <div class="button_wrapper">
            <button @click="save" class="btn btn-accent clear-btn" :disabled="isSaving">Сохранить</button>
          </div>
        </div>
        <div v-else class="preloader">
          <preloader/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import useCheckRights from "@/mixins/useCheckRights";
  import {computed, reactive, ref} from "@vue/reactivity";
  import {useRoute, useRouter} from "vue-router";
  import {useStore} from "vuex";
  import {onBeforeMount, watch} from "@vue/runtime-core";
  import CustomSelect2 from "@/components/Forms/Fields/CustomSelect2.vue";
  import CustomInput from "@/components/Forms/Fields/CustomInput.vue";
  import Preloader from "@/components/Technical/Preloader.vue";
  import CustomTextarea from "@/components/Forms/Fields/CustomTextarea.vue";
  import {notify} from "@kyvg/vue3-notification";

  const {getRight} = useCheckRights();
  const route = useRoute();
  const router = useRouter();
  const user = computed(() => store.state.profile.profile);
  const text = computed(() => store.state.newReport.text);
  const currentTextTypes = computed(() => store.state.newReport.currentTitles);
  const store = useStore();
  const isSaving = ref(false);

  const loadPreloader = ref(false);

  const form = reactive({
    title: "",
    text: "",
    report_type: 'employee',
    scores1_from: 0,
    scores1_to: 150,
    scores2_from: 0,
    scores2_to: 150,
  })

  const save = () => {
    form.first_score = [parseInt(form.scores1_from), parseInt(form.scores1_to)];
    form.second_score = [parseInt(form.scores2_from), parseInt(form.scores2_to)];

    if (!form.title) {
      notify({
        type: "warning",
        title: "Поле заголовок обязательно к заполнению",
      });
      return;
    }

    if (!form.text) {
      notify({
        type: "warning",
        title: "Поле текст обязательно к заполнению",
      });
      return;
    }

    isSaving.value = true;

    if (!route.params.id) {
      createNew();
    } else {
      update();
    }
  }

  const createNew = () => {
    store.dispatch('newReport/createText', form).then(() => {
      isSaving.value = false;
      router.push('/new_reports/texts');
    })
  }

  const update = () => {
    form.id = route.params.id;

    store.dispatch('newReport/updateText', form).then(() => {
      isSaving.value = false;
    })
  }

  const prepareData = () => {
    loadPreloader.value = true;
    if (route.params.id && !form.title) {
      store.dispatch('newReport/getText', route.params.id).then(() => {
        Object.entries(form).forEach(([entry, value]) => {
          form[entry] = text.value[entry];
        });
        loadPreloader.value = false;
      });
    } else if (!currentTextTypes.value.length) {
      store.dispatch('newReport/getTitles', form.report_type).then(() => {
        loadPreloader.value = false;
      })
    }
  }

  onBeforeMount(() => {
    if (getRight('reportTextEdition') && user.value?.id) {
        prepareData();
    }
  });

  watch(() => [form.report_type], () => {
    if (!route.params.id) {
      store.dispatch('newReport/getTitles', form.report_type);
    }
  })

  watch(() => user.value,() => {
    if (user.value?.id) {
      if (!getRight('reportTextEdition')) {
        router.push('/');
      } else if (!currentTextTypes.value.length || !form.title) {
        prepareData();
      }
    }
  });
</script>

<style scoped lang="scss">
.preloader {
  padding: 100px;
  text-align: center;
}

.textarea_wrapper {
  padding: 0 10px;
}

.button_wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .textarea_wrapper {
    margin: 20px 0;
    padding: 0;
  }

  .score_group {
    margin-top: 10px;
  }
}
</style>